/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const SLOTS = {
    input: "input",
};
export const CSS = {
    label: "label",
    labelScale: (scale) => `label--scale-${scale}`,
    labelHorizontal: "label--horizontal",
    labelOutline: "label--outline",
    labelOutlineFill: "label--outline-fill",
    icon: "icon",
    iconSolo: "icon--solo",
};
//# sourceMappingURL=resources.js.map
